<!-- 缺省页面 -->
<template>
    <div class="default-container">
        <img class="imgdefault" src="@/assets/images/default.png" alt="">
        <span class="text">{{ textContent || $t("common.noData") }}</span>
    </div>
</template>
<script>
export default {
    props: {
        textContent: {
            default: ''
        }
    },
};
</script>
<style lang='less' scoped>
.default-container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 54px 0;
    width: 100%;
    .imgdefault{
        height: 80px;
        width: 80px;
        margin-bottom: 28px;
    }
    .text{
        color: #818999;
        font-size: 15px;
    }
}
</style>